import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Mint from 'bh-mint-ui2';
import { Toast } from 'bh-mint-ui2';
import route from './router';
import * as utils from './utils'
import api from './api'
import axios from 'axios'
import 'bh-mint-ui2/lib/style.css'
import init from 'bh-mixin-sdk'
import ViewUI from 'view-design';

Vue.use(ViewUI)
import store from './store/index'

if (window.smile) {
  window.Vue = Vue
  window.axios = axios
  if (WEBPACK_CONFIG_HOST) {
      window.WEBPACK_CONFIG_HOST = WEBPACK_CONFIG_HOST
  }
  // 初始化eventBus
  window.smile.eventBus = new Vue()
}
if(location.href.indexOf('service=') != -1) {
    let service = location.href.split('service=')[1]
    localStorage.setItem('services',service)
    location.href = location.origin+location.pathname
}
Vue.use(Mint);
Vue.use(VueRouter);
const router = new VueRouter(route);

router.beforeEach((to, from, next) => {
  // 加载页面smile依赖
  if (window.smile) {
      var require = []
      var promiseArr = []
      // 拉取require配置中的表单
      if (to.meta.require && to.meta.require.length > 0) {
          require = require.concat(to.meta.require)
      }
      // 拉取传参中的表单
      if (to.query.smileForm) {
          require.push(to.query.smileForm)
      }
      require.map(function(item) {
          if (!window.smile.components[item]) {
              promiseArr.push(window.smile.loadPage(item))
          }
      })
      if (promiseArr.length > 0) {
          Promise.all(promiseArr).then(function() {
              next()
          })
      } else {
          next()
      }
  } else {
      next()
  }
})

global.SDK = null;
function getSDKConfig() {
  return new Promise((resolve, reject) => {
    let config = {
      dd: {}, //钉钉jdk初始化参数
    }
    if (/micromessenger/.test(navigator.userAgent.toLowerCase()) && config.wx) {
      /**
       * 判断运行环境为微信时，向后端发送请求获取微信jsdk的授权签名，（此接口应该有后端来提供），请求返回应包含以下参数
       * corpId - 企业号的corpid
       * nonceStr - 生成签名的随机串
       * timestamp - 生成签名的时间戳
       * signature - 签名
       */
      // TODO: 发请求获取微信签名
      config.wx.url = "http://res.wisedu.com:9090/checkSign";
      utils.Get(api.getWechatSign, { url: window.location.href.replace(/#(\S+)?/, ''),corp:'amptest' }).then(({
        data: resp
      }) => {
        if (resp.code == "0") {
          let signData = resp.data
          signData.corpId = signData.corpId
          signData.nonceStr = signData.nonceStr
          config.wx.signData = signData
          resolve(config)
        } else {
          Toast('微信jsdk初始化失败 ' + resp.code);
          reject(resp)
        }
      }, () => {
        Toast('微信jsdk初始化失败');
        reject()
      })
    } else {
      setTimeout(function () {
        resolve(config)
      }, 0)
    }
    return config
  })
}

getSDKConfig().then((config) => {
  init((res) => {
    if (res.type === 'success') {
      global.SDK = res.sdk;

      new Vue({
        el: '#app',
        router,
        store,
        template: '<App/>',
        components: {
          App
        }
      });
    }
  }, config)
})



// WEBPACK FOOTER //
// ./src/main.js